<template>
  <div
    ref="watermarkBox"
    class="component-container"
    :class="{ 'watermask-full-screen': isFullScreen }"
    style="pointer-events: none"
  >
    <div ref="scrollNotice" class="notice scrolling-notice"></div>
    <div class="content-box" ref="contentBox"></div>
  </div>
</template>

<script>
import { createMarquee } from "@saas/components/src/utils/marquee";
import { setWatermark } from "@saas/components/src/utils/watermark";
import { createAnnouncementScroll } from "@saas/components/src/utils/announcement-scroll";
const densityMap = {
  1: "low",
  2: "medium",
  3: "high",
};
const speedMap = {
  1: 20,
  2: 50,
  3: 100,
};
export default {
  props: {
    lessonDetail: {
      type: Object,
      default: () => {},
    },
    userName: {
      type: String,
      default: "-(-)",
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 风险防控开关是否开启
    riskConfigSwitch() {
      return this.lessonDetail.risk_control_switch === 1;
    },
    // 用户水印开关是否开启
    userWatermarkSwitch() {
      return (
        this.riskConfigSwitch && this.riskConfig.user_watermark_switch === 1
      );
    },
    // 版权声明开关是否开启
    copyrightNoticeSwitch() {
      return (
        this.riskConfigSwitch && this.riskConfig.copyright_notice_switch === 1
      );
    },
    riskConfig() {
      return this.lessonDetail.risk_control_config || {};
    },
    user() {
      return this.$store.getters.user;
    },
    watermarkText() {
      return `<div style="display: flex;align-items: center; justify-content: center;">
        <span
          style="max-width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
           white-space: nowrap;
           display: inline-block;">${this.user.nickname || "-"}</span>
        <span>（${this.user.mobile || "-"}）</span>
        </div>`;
    },
  },
  watch: {
    lessonDetail: {
      handler(val) {
        if (val) {
          this.initUserWatermark();
          this.initAnnouncementScroll();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      marqueeInstance: null,
      announcementScrollInstance: null,
      watermarkInstance: null,
    };
  },
  beforeDestroy() {
    if (this.marqueeInstance) {
      this.marqueeInstance.destroy();
    }
  },
  mounted() {
    this.initUserWatermark();
    this.initAnnouncementScroll();
  },
  methods: {
    // 初始化用户水印
    initUserWatermark() {
      if (
        !this.$refs.contentBox ||
        !this.lessonDetail.lesson_id ||
        !this.riskConfigSwitch ||
        !this.userWatermarkSwitch
      ) {
        return;
      }
      if (this.riskConfig.user_watermark_type === 1) {
        // 跑马灯
        this.initMarquee();
      } else {
        // 固定水印
        this.initWatermark();
      }
    },
    // 初始化跑马灯
    initMarquee() {
      const opacity = (this.riskConfig.user_watermark_diaphaneity || 50) / 100;
      const speed = speedMap[this.riskConfig.user_watermark_frequency || 1];
      const fontSize = (this.riskConfig.user_watermark_size || 12) + "px";
      this.marqueeInstance = createMarquee(
        this.$refs.contentBox,
        this.watermarkText,
        {
          speed: speed,
          fontSize: fontSize,
          opacity: opacity,
        }
      );
      this.marqueeInstance.start();
    },
    // 初始化水印
    initWatermark() {
      const opacity = (this.riskConfig.user_watermark_diaphaneity || 50) / 100;
      const density = densityMap[this.riskConfig.user_watermark_density || 1];
      const fontSize = (this.riskConfig.user_watermark_size || 12) + "px";
      // 固定水印
      this.watermarkInstance = setWatermark({
        container: this.$refs.contentBox,
        watermarkText: this.watermarkText,
        density: density,
        fontSize: fontSize,
        opacity: opacity,
      });
    },
    initAnnouncementScroll() {
      if (
        !this.$refs.scrollNotice ||
        !this.lessonDetail.lesson_id ||
        !this.riskConfigSwitch ||
        !this.copyrightNoticeSwitch
      ) {
        return;
      }
      const copyRightSwitch = this.riskConfig.copyright_notice_switch === 1;
      // 版权声明开启
      if (copyRightSwitch) {
        const mode =
          this.riskConfig.copyright_notice_type === 1 ? "interval" : "infinite";
        const config = {
          color: "#fff",
          fontSize: "12px",
          mode: mode,
          interval: 1000 * 60 * 10,
          speed: 50,
          backgroundColor: "rgba(51, 51, 51, 0.2)",
        };
        const content = this.riskConfig.copyright_notice || "-";
        this.announcementScrollInstance = createAnnouncementScroll(
          this.$refs.scrollNotice,
          [content],
          config
        );
        this.announcementScrollInstance.start();
      } else {
        if (this.announcementScrollInstance) {
          this.announcementScrollInstance.destroy();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.component-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.scrolling-notice {
  height: 28px;
  min-height: 28px;
  //   background: rgba(51, 51, 51, 0.2);
}
.content-box {
  flex: 1;
}
</style>
